import Swiper from "swiper";
import swiperSettings from "./swiper-settings";

export default function() {
  document.addEventListener('DOMContentLoaded', () => {

    let swiperInstances = {}

    let grids = [...document.querySelectorAll('[data-media-copy-grid]')]
    let mql = window.matchMedia("(min-width: 768px");

    if (grids.length === 0) {
      return;
    }

    function updateCarousels() {
      grids.forEach((grid, index) => {

        if (!mql.matches) {
          // Create a swiper instance for mobile
          swiperInstances[index] = new Swiper(grid.querySelector('.swiper'), {
            ...swiperSettings,
            breakpoints: {
            }
          })
          return;
        }

        if (swiperInstances[index]) {
          swiperInstances[index].destroy()
          swiperInstances[index] = undefined;
        }
      })
    }

    mql.addEventListener("change", () => {
      updateCarousels()
    });

    updateCarousels()
  })
}
